import {
    createRouter,
    createWebHistory
} from 'vue-router'
import store from '../store';

const routes = [{
        path: '/',
        redirect: {
            name: 'dashboard'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard'),
        meta: {
            title: '工作台',
            login: true
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) document.title = to.meta.title;

    if (to.meta.login)
    {
        if (store.getters['user/isLogin']())
        {
            next();
        } 
        else
        {
            next({
                path: '/login'
            });
        }
    } 
    else
    {
        next();
    }
});

router.afterEach((to, from, next) => {
    scrollTo(0, 0);
});

export default router